import React, { useRef, useEffect, useState, forwardRef } from 'react';
import Playbar from '../../../Common/Video/Playbar';
import {
  useVideoFragmentStore,
  getStore,
} from '../../../../stores/StoreContext';
import { View } from '@smarterservices/smarter-ui';
const ProgressBar = forwardRef(
  ({ videoRef, onSeek, handleSeek: externalHandleSeek, fragmentId }, ref) => {
    const playbarRef = useRef(null);
    const [adjustedCurrentTime, setAdjustedCurrentTime] = useState(0);
    const [adjustedDuration, setAdjustedDuration] = useState(0);
    const [keyPeriodLeftMargin, setKeyPeriodLeftMargin] = useState(0);
    const [keyPeriodWidth, setKeyPeriodWidth] = useState(0);

    const VideoFragmentStore = getStore('videoFragmentStore');
    const leadInTime = useVideoFragmentStore(
      (state) => state[fragmentId]?.state?.leadInTime
    );
    const leadOutTime = useVideoFragmentStore(
      (state) => state[fragmentId]?.state?.leadOutTime
    );

    const currentTime = useVideoFragmentStore(
      (state) => state[fragmentId]?.state?.currentTime
    );
    const startTime = useVideoFragmentStore(
      (state) => state[fragmentId]?.state?.startTime
    );
    const endTime = useVideoFragmentStore(
      (state) => state[fragmentId]?.state?.endTime
    );
    const isPlaying = useVideoFragmentStore(
      (state) => state[fragmentId]?.state?.isPlaying
    );

    useEffect(() => {
      // calculate the key period left margin and width as percentages of the whole duration
      const duration = endTime - startTime;
      const keyPeriodStart = startTime + leadInTime;
      const keyPeriodEnd = endTime - leadOutTime;
      const keyPeriodLeftMargin = Math.round((leadInTime / duration) * 100);
      const keyPeriodWidth = Math.round(((keyPeriodEnd - keyPeriodStart) / duration) * 100);
      setKeyPeriodLeftMargin(keyPeriodLeftMargin);

      if (keyPeriodWidth === 0) {
        setKeyPeriodWidth(3);
      }
      
      console.log('keyPeriodLeftMargin', keyPeriodLeftMargin);
      console.log('keyPeriodWidth', keyPeriodWidth);


    }, [startTime, endTime]);

    useEffect(() => {
      if (!isPlaying) return;
      const duration = endTime - startTime;
      const adjustedCurrentTime = currentTime - startTime;
      setAdjustedCurrentTime(adjustedCurrentTime);
      setAdjustedDuration(duration);
    }, [currentTime, startTime, endTime, isPlaying]);

    // Use the external handleSeek if provided, otherwise create our own
    const handleSeek = (newTime) => {
      // since this is a fragment, we need to add the time from the play bar to the start time of the fragment...
      const seekTime = Math.round(newTime + startTime);
      VideoFragmentStore.play(fragmentId, seekTime);
      // Call the onSeek callback if provided
      if (onSeek) {
        onSeek(seekTime);
      }
    };

    return (
      <>
      <div
        style={{
          width: '100%',
          padding: '4px 0',
        }}
        ref={ref} // Pass the forwarded ref to the outer div
      >
        <Playbar
          ref={playbarRef} // Use internal ref for Playbar
          duration={adjustedDuration}
          currentTime={adjustedCurrentTime}
          onSeek={handleSeek}
          onDragStart={(time) => {
            // Pause video while dragging
            if (videoRef?.current) {
              videoRef.current.pause();
            }
          }}
          onDrag={(time) => {
            // Optional: Update preview frame or time display if needed
          }}
          onDragEnd={(time) => {
            // Seek and resume playback
            if (videoRef?.current) {
              videoRef.current.currentTime = time;
              videoRef.current.play();
            }
          }}
          height="8px"
          progressColor="brand"
          borderRadius="small"
        />
      </div>
      <View as="div" width="100%" height="4px" margin="none" withVisualDebug={false}>
          <View as="div" width={`${keyPeriodWidth}%`} 
                height="4px" 
                margin="none none none small" 
                withVisualDebug={false} 
                background='info'
                themeOverride={{
                  marginSmall: `${keyPeriodLeftMargin}%`
                }} />
          
      </View>
      </>
    );
  }
);

export default ProgressBar;
